/* =============================================================
   PROMPTVAULT — CART DRAWER  (real Shopify AJAX cart)

   Reworked from the standalone demo: instead of a localStorage
   mock it drives the *actual* Shopify cart via /cart/add,
   /cart/change and /cart/update, reads state from /cart.js, and
   checks out to /checkout. Config (variant ids, prices, routes,
   money format) is injected by snippets/pv-cart.liquid as
   window.PV_CART.

   Bilingual: every label is rendered as data-lang="en"/"es" spans,
   so the site-wide language switch (pv-lang-init) shows the right
   one with no re-render.

   One of each: every product here is a digital delivery, so a line never
   goes above quantity 1. addVariant refuses an add for something the cart
   already holds (and says so in the drawer), and clampLines pulls any line
   that got past that back down to 1 on every read of the cart.

   Public API (also on window.PVCart):
     PVCart.open() / close()
     PVCart.add('youtube')     add a course/bundle by catalog id
     PVCart.addVariant(id)     add any variant id
     PVCart.remove(variantId)  remove a line by variant id
     PVCart.items()            -> raw Shopify cart items

   Nothing on the storefront may navigate to /cart — the drawer *is*
   the cart, and checkout is its only exit. So we intercept, globally:
     - submits of any product form  (action contains /cart/add)
     - clicks on /cart/<variant>:<qty> permalinks
     - clicks on /cart itself
     - data-cart-open        opens the drawer
     - data-cart-add="<catalog id>" / data-cart-add-variant="<id>"
   Each still carries a working href/form so the page degrades to plain
   Shopify if this script fails to load.
   ============================================================= */
(function () {
  'use strict';

  var CFG = window.PV_CART || {};
  var PRODUCTS = Array.isArray(CFG.products) ? CFG.products : [];
  var ROUTES = CFG.routes || {};
  var MONEY_FORMAT = CFG.money_format || '€{{amount}}';

  // An empty catalog is survivable: template-suffix detection may have failed
  // in the admin, but intercepted forms carry their own variant id, so the
  // drawer still adds, renders and checks out. Only the quick-add/upsell
  // extras (which need the catalog) go quiet.
  var byId      = function (id)  { return PRODUCTS.filter(function (p) { return p.id === id; })[0]; };
  var byVariant = function (vid) { return PRODUCTS.filter(function (p) { return p.variantId === vid; })[0]; };
  var BUNDLE    = byId('bundle');
  var COURSES   = PRODUCTS.filter(function (p) { return p.id !== 'bundle'; });

  /* ---- money -------------------------------------------------------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^\d.-]/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal   = decimal   == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      // Sin centimos cuando son cero, como el filtro money_without_trailing_zeros
      // de Liquid: los botones y el carrito ponen "80", no "80,00".
      var cents = parts[1] && !/^0+$/.test(parts[1]) ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var m = MONEY_FORMAT.match(placeholder);
    if (!m) return MONEY_FORMAT;
    var value;
    switch (m[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2); break;
    }
    return MONEY_FORMAT.replace(placeholder, value);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  // Bilingual inline: renders both languages; the global lang CSS hides one.
  function L(en, es) {
    return '<span data-lang="en">' + esc(en) + '</span>' +
           '<span data-lang="es">' + esc(es == null ? en : es) + '</span>';
  }
  /* Attributes (aria-label, title) can only hold one language, so they read
     the active one and are refreshed on 'pv:langchange'. Everything visible
     goes through L() above and needs no refresh. */
  function LA(en, es) {
    var l = (window.PVLang && PVLang.get && PVLang.get()) ||
            document.documentElement.getAttribute('data-pv-lang') || 'en';
    return l === 'es' && es != null ? es : en;
  }
  function syncAria() {
    if (!root) return;
    var d = root.querySelector('.pv-cart-drawer');
    if (d) d.setAttribute('aria-label', LA('Cart', 'Carrito'));
    var c = root.querySelector('.pv-cart-close');
    if (c) c.setAttribute('aria-label', LA('Close', 'Cerrar'));
    document.querySelectorAll('.pv-cart-btn').forEach(function (b) {
      b.setAttribute('aria-label', LA('Open cart', 'Abrir carrito'));
    });
  }
  function nameOf(p)  { return p && p.name ? L(p.name.en, p.name.es) : ''; }
  function subOf(p)   { return p && p.sub  ? L(p.sub.en,  p.sub.es)  : ''; }

  /* ---- live cart state (from /cart.js) ------------------------------ */
  var cartState = { items: [], item_count: 0, total_price: 0, items_subtotal_price: 0 };
  var busy = false;

  function inCart(variantId) {
    return cartState.items.some(function (i) { return i.variant_id === variantId; });
  }
  function courseItemsInCart() {
    return cartState.items.filter(function (i) {
      var p = byVariant(i.variant_id); return p && p.id !== 'bundle';
    });
  }

  function fetchConfig(body) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    };
  }
  function refreshCart() {
    return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return clampLines(c); });
  }

  /* One of each, always.
     Everything sold here is a digital delivery: a second copy of the same line
     bills twice for files the buyer already gets once, so a quantity above 1 is
     never something we want to charge for. addVariant refuses the duplicate
     before it is sent, and this is the net underneath it, for the ways a bigger
     quantity can still turn up: an intercepted product form carrying a quantity
     input, a /cart/<variant>:3 permalink, a line left in the cart from an
     earlier visit, or an add made while this script was not loaded. Anything
     over 1 comes straight back down to 1 on the next read of the cart.
     Keyed by line key rather than variant id, so a line is clamped on its own
     terms and two lines of the same variant are not merged behind the scenes. */
  function clampLines(cart) {
    var updates = {};
    var over = false;
    (cart.items || []).forEach(function (i) {
      if (i.quantity > 1) { updates[i.key] = 1; over = true; }
    });
    if (!over) return cart;
    return fetch(ROUTES.update, fetchConfig({ updates: updates }))
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return c; })
      .catch(function () { return cart; });
  }
  function apiAdd(variantId)          { return fetch(ROUTES.add,    fetchConfig({ id: variantId, quantity: 1 })); }
  function apiChangeKey(key, qty)     { return fetch(ROUTES.change, fetchConfig({ id: key, quantity: qty })); }
  function apiZero(variantIds) {
    if (!variantIds.length) return Promise.resolve();
    var updates = {};
    variantIds.forEach(function (v) { updates[v] = 0; });
    return fetch(ROUTES.update, fetchConfig({ updates: updates }));
  }

  /* ---- mutations ---------------------------------------------------- */
  function setBusy(b) {
    busy = b;
    if (root) root.classList.toggle('is-busy', b);
  }
  function mutate(runner) {
    if (busy) return;
    setBusy(true);
    lastError = null;
    clearDuplicate();
    Promise.resolve()
      .then(runner)
      .then(refreshCart)
      .then(function () { setBusy(false); render(); syncBadge(); })
      .catch(function (e) {
        setBusy(false);
        lastError = true;
        render();
        // eslint-disable-next-line no-console
        console.error('[pv-cart]', e);
      });
  }

  // Everything routes through here — catalog buttons, intercepted product
  // forms and /cart permalinks all end up adding one variant id.
  function addVariant(variantId, opts) {
    variantId = parseInt(variantId, 10);
    if (!variantId) return;
    var known = byVariant(variantId);
    var isBundle = BUNDLE && BUNDLE.variantId === variantId;

    // Already there: nothing to add. The drawer opens on the line it already
    // holds and says so, rather than silently doing nothing or quietly
    // charging for a second copy of the same download.
    if (inCart(variantId)) {
      noteDuplicate(variantId);
      open();
      return;
    }

    mutate(function () {
      if (isBundle) {
        // Bundle replaces the individual courses.
        var courseVars = courseItemsInCart().map(function (i) { return i.variant_id; });
        return apiZero(courseVars).then(function () { return apiAdd(variantId); });
      }
      // Adding a known course cancels the bundle. An unknown variant (some
      // other product) has no such relationship, so it just gets added.
      var pre = known && BUNDLE && inCart(BUNDLE.variantId)
        ? apiZero([BUNDLE.variantId])
        : Promise.resolve();
      return pre.then(function () { return apiAdd(variantId); });
    });
    if (opts && opts.open) open();
  }

  function add(id, opts) {
    var p = byId(id);
    if (!p || !p.variantId) return false;
    addVariant(p.variantId, opts);
    return true;
  }
  /* The "already in your cart" message. Held as a variant id so render() can
     mark that one line, and cleared on a timer so it does not stay on screen
     for the rest of the session. */
  var dupVariant = null, dupTimer = null;
  function noteDuplicate(variantId) {
    dupVariant = variantId;
    clearTimeout(dupTimer);
    dupTimer = setTimeout(function () { dupVariant = null; render(); }, 4000);
    render();
  }
  function clearDuplicate() {
    if (dupVariant == null) return;
    dupVariant = null;
    clearTimeout(dupTimer);
  }

  function removeVariant(variantId) {
    var item = cartState.items.filter(function (i) { return i.variant_id === variantId; })[0];
    if (!item) return;
    mutate(function () { return apiChangeKey(item.key, 0); });
  }

  /* ---- per-course colour -------------------------------------------- */
  /* The drawer chrome follows the page accent (see syncTheme), but each
     course row re-scopes --pv-accent to that course's own colour, which the
     badge, the plus sign and the hover border already read from — so no new
     rules are needed, only the override. Values mirror each course page CSS.
     The bundle is deliberately absent: it stands for all three courses, so it
     keeps whatever accent the current page has. */
  var COURSE_THEME = {
    ecommerce: ['#4fe884', 'rgba(79,232,132,.13)', 'rgba(79,232,132,.32)'],
    youtube:   ['#ff2b2b', 'rgba(255,43,43,.13)',  'rgba(255,43,43,.32)'],
    marketing: ['#4f9cff', 'rgba(79,156,255,.14)', 'rgba(79,156,255,.32)'],
    code:      ['#d97757', 'rgba(217,119,87,.14)', 'rgba(217,119,87,.32)']
  };
  function themeStyle(p) {
    var t = p && COURSE_THEME[p.id];
    if (!t) return '';
    return ' style="--pv-accent:' + t[0] +
           ';--pv-accent-soft:' + t[1] +
           ';--pv-accent-line:' + t[2] + '"';
  }

  /* ---- SVG ---------------------------------------------------------- */
  var CART_SVG = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle><path d="M2 3h2.2l2.1 12.2a1.6 1.6 0 0 0 1.6 1.3h8.8a1.6 1.6 0 0 0 1.6-1.3L21 7H5.4"></path></svg>';
  var CART_SVG_BIG = CART_SVG.replace(/17/g, '24').replace('stroke-width="2"', 'stroke-width="1.8"');
  var TRASH_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"></path><path d="M10 4.5h4a1 1 0 0 1 1 1V7H9V5.5a1 1 0 0 1 1-1z"></path><path d="M6.5 7l.8 11.4a1.6 1.6 0 0 0 1.6 1.5h6.2a1.6 1.6 0 0 0 1.6-1.5L17.5 7"></path><path d="M10.5 10.8v5.6M13.5 10.8v5.6"></path></svg>';
  var LOCK_SVG ='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10.5" width="16" height="10" rx="2.2"></rect><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"></path></svg>';

  /* ---- drawer DOM --------------------------------------------------- */
  var root, bodyEl, subEl, footEl, lastError = false;

  function buildShell() {
    root = document.createElement('div');
    root.className = 'pv-cart';
    root.innerHTML =
      '<div class="pv-cart-overlay" data-cart-close></div>' +
      '<aside class="pv-cart-drawer" role="dialog" aria-label="' + LA('Cart', 'Carrito') + '">' +
        '<div class="pv-cart-head">' +
          '<div class="pv-cart-head-l">' +
            '<span class="pv-cart-ico">' + CART_SVG + '</span>' +
            '<div><div class="pv-cart-title">' + L('your cart', 'tu carrito') + '</div>' +
            '<div class="pv-cart-sub" data-cart-sub></div></div>' +
          '</div>' +
          '<button class="pv-cart-close" data-cart-close aria-label="' + LA('Close', 'Cerrar') + '">✕</button>' +
        '</div>' +
        '<div class="pv-cart-body" data-cart-body></div>' +
        '<div class="pv-cart-foot pv-hidden" data-cart-foot></div>' +
      '</aside>';
    document.body.appendChild(root);
    bodyEl = root.querySelector('[data-cart-body]');
    subEl  = root.querySelector('[data-cart-sub]');
    footEl = root.querySelector('[data-cart-foot]');

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-cart-close]') : null;
      if (t) close();
    });
  }

  /* ---- render ------------------------------------------------------- */
  function render() {
    if (!root) return;
    var items = cartState.items || [];
    var count = cartState.item_count || 0;

    subEl.innerHTML = count === 1 ? '1 ' + L('item', 'artículo')
                                  : count + ' ' + L('items', 'artículos');

    var errHTML = lastError
      ? '<div class="pv-cart-error">' + L(
          'Something went wrong updating your cart. Please try again.',
          'Algo salió mal al actualizar tu carrito. Inténtalo de nuevo.') + '</div>'
      : '';

    // ---- empty ----
    if (!count) {
      var quick = COURSES.length
        ? '<div class="pv-cart-label">' + L('quick add', 'añadir rápido') + '</div>' +
          '<div class="pv-cart-lines">' + COURSES.map(function (p) { return addRow(p, false); }).join('') + '</div>'
        : '';
      bodyEl.innerHTML = errHTML +
        '<div class="pv-cart-empty">' +
          '<div class="pv-cart-empty-ico">' + CART_SVG_BIG + '</div>' +
          '<div class="pv-cart-empty-h">' + L('Your cart is empty', 'Tu carrito está vacío') + '</div>' +
          '<p class="pv-cart-empty-p">' + L(
            'Add a course to get started: you get the course, its Agent Creation module and lifetime updates.',
            'Añade un curso para empezar: te llevas el curso, su módulo de Creación de Agentes y actualizaciones de por vida.') + '</p>' +
        '</div>' + quick;
      footEl.classList.add('pv-hidden');
      wire();
      return;
    }

    // ---- lines ----
    var lines = items.map(function (i) {
      var p = byVariant(i.variant_id);
      var badge = p ? p.badge : (i.product_title || '?').slice(0, 2).toLowerCase();
      var name  = p ? nameOf(p) : esc(i.product_title || '');
      var sub   = p ? subOf(p)  : '';
      var isDup = dupVariant === i.variant_id;
      return '<div class="pv-cart-line' + (isDup ? ' is-dup' : '') + '"' + themeStyle(p) + '>' +
        '<span class="pv-cart-badge">' + esc(badge) + '</span>' +
        '<div class="pv-cart-line-main"><div class="pv-cart-line-name">' + name + '</div>' +
        (sub ? '<div class="pv-cart-line-sub">' + sub + '</div>' : '') + '</div>' +
        '<div class="pv-cart-line-side"><div class="pv-cart-line-price">' + esc(formatMoney(i.final_line_price)) + '</div>' +
        // Icon-only button; the visually-hidden span carries the accessible
        // name, so it stays bilingual (aria-label could only hold one language).
        '<button class="pv-cart-remove" data-remove="' + i.variant_id + '">' + TRASH_SVG +
        '<span class="pv-sr">' + L('remove', 'quitar') + '</span></button></div>' +
        '</div>';
    }).join('');

    var dupHTML = dupVariant != null && inCart(dupVariant)
      ? '<div class="pv-cart-note">' + L(
          'That course is already in your cart. One copy is all you need: you get the whole course and every update with it.',
          'Ese curso ya está en tu carrito. Con una copia te llega todo: el curso completo y todas sus actualizaciones.') + '</div>'
      : '';

    var html = errHTML + '<div class="pv-cart-lines">' + lines + '</div>' + dupHTML;

    var hasBundle = BUNDLE && inCart(BUNDLE.variantId);
    var courseCount = courseItemsInCart().length;

    // ---- add another (only when not on the bundle) ----
    if (!hasBundle) {
      var remaining = COURSES.filter(function (p) { return p.variantId && !inCart(p.variantId); });
      if (remaining.length) {
        html += '<div class="pv-cart-label">' + L('add another', 'añade otro') + '</div>' +
                '<div class="pv-cart-lines">' + remaining.map(function (p) { return addRow(p, true); }).join('') + '</div>';
      }
    }

    /* ---- bundle upsell ----
       Counted off the live catalog rather than a hard-coded 4, so merging or
       adding a course changes the copy on its own. Two cases: one course short
       of the set, or holding the whole set already. */
    var totalCourses = COURSES.length;
    if (BUNDLE && BUNDLE.variantId && !hasBundle && totalCourses > 1 && courseCount >= totalCourses - 1) {
      var soFar = formatMoney(courseItemsInCart().reduce(function (n, i) { return n + i.final_line_price; }, 0));
      var bundleP = BUNDLE.priceText || formatMoney(BUNDLE.price);
      if (courseCount < totalCourses) {
        html += upsell(
          L('You have ' + courseCount + ' courses (' + soFar + '). Get all ' + totalCourses + ' plus The Master Claude Ebook in the full bundle for ' + bundleP + '.',
            'Tienes ' + courseCount + ' cursos (' + soFar + '). Consigue los ' + totalCourses + ' más The Master Claude Ebook en el pack completo por ' + bundleP + '.'),
          L('Switch to the bundle · ' + bundleP, 'Cambiar al pack · ' + bundleP));
      } else {
        html += upsell(
          L('All ' + totalCourses + ' courses add up to ' + soFar + '. The full bundle is ' + bundleP + ' but adds The Master Claude Ebook and every future course.',
            'Los ' + totalCourses + ' cursos suman ' + soFar + '. El pack completo cuesta ' + bundleP + ' pero añade The Master Claude Ebook y todos los cursos futuros.'),
          L('Add The Master Claude Ebook · ' + bundleP, 'Añadir The Master Claude Ebook · ' + bundleP));
      }
    }

    bodyEl.innerHTML = html;

    // ---- footer ----
    var subtotal = formatMoney(cartState.items_subtotal_price != null ? cartState.items_subtotal_price : cartState.total_price);
    var total    = formatMoney(cartState.total_price);
    footEl.innerHTML =
      '<div class="pv-cart-row"><span>' + L('Subtotal', 'Subtotal') + '</span><span class="mono">' + esc(subtotal) + '</span></div>' +
      '<div class="pv-cart-total"><span class="pv-cart-total-l">' + L('Total', 'Total') + '</span><span class="pv-cart-total-v">' + esc(total) + '</span></div>' +
      '<button class="pv-cart-checkout" data-checkout>' + L('Checkout ' + total, 'Pagar ' + total) + '</button>' +
      '<div class="pv-cart-secure">' + LOCK_SVG + ' ' + L('secure checkout · instant access', 'pago seguro · acceso inmediato') + '</div>';
    footEl.classList.remove('pv-hidden');

    wire();
  }

  function addRow(p, dashed) {
    var price = p.priceText || formatMoney(p.price);
    return '<button class="pv-cart-add' + (dashed ? ' is-dashed' : '') + '" data-add="' + esc(p.id) + '"' + themeStyle(p) + '>' +
      '<span class="pv-cart-badge">' + esc(p.badge) + '</span>' +
      '<span class="pv-cart-add-name">' + nameOf(p) + '</span>' +
      '<span class="pv-cart-add-price">' + esc(price) + '</span>' +
      '<span class="pv-cart-add-plus">+</span></button>';
  }
  function upsell(textHTML, ctaHTML) {
    return '<div class="pv-cart-upsell"><div class="pv-cart-upsell-tag">' + L('◆ bundle deal', '◆ oferta pack') + '</div>' +
      '<p class="pv-cart-upsell-p">' + textHTML + '</p>' +
      '<button class="pv-cart-upsell-btn" data-add="bundle">' + ctaHTML + '</button></div>';
  }

  function wire() {
    bodyEl.querySelectorAll('[data-add]').forEach(function (b) {
      b.onclick = function () { add(b.getAttribute('data-add')); };
    });
    bodyEl.querySelectorAll('[data-remove]').forEach(function (b) {
      b.onclick = function () { removeVariant(parseInt(b.getAttribute('data-remove'), 10)); };
    });
    var co = footEl.querySelector('[data-checkout]');
    if (co) co.onclick = function () {
      if (busy) return;
      co.innerHTML = L('Redirecting to checkout…', 'Redirigiendo al pago…');
      window.location.href = ROUTES.checkout || '/checkout';
    };
  }

  /* ---- header button + badge --------------------------------------- */
  function buildButton() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pv-cart-btn';
    b.setAttribute('data-cart-open', '');
    b.setAttribute('aria-label', LA('Open cart', 'Abrir carrito'));
    b.innerHTML = CART_SVG +
      '<span class="pv-cart-btn-label">' + L('cart', 'carrito') + '</span>' +
      '<span class="pv-cart-count" data-cart-count data-empty="true">0</span>';
    return b;
  }
  var MOUNTS = ['[data-pv-cart-mount]', '.nav__links', '.nav-links', '.cm-nav-links'];
  function findMount() {
    for (var i = 0; i < MOUNTS.length; i++) {
      var el = document.querySelector(MOUNTS[i]);
      if (el) return el;
    }
    return null;
  }
  function mountButton() {
    var host = findMount();
    if (!host || host.querySelector('.pv-cart-btn')) return !!host;
    host.appendChild(buildButton());
    syncBadge();
    return true;
  }
  function ensureButton() {
    if (mountButton()) return;
    // Nav is rendered later (e.g. the JS-built code page) — watch for it.
    var obs = new MutationObserver(function () { if (mountButton()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    // Safety: stop watching after 10s.
    setTimeout(function () { obs.disconnect(); }, 10000);
  }
  function syncBadge() {
    var n = cartState.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    });
    window.dispatchEvent(new CustomEvent('cart:count', { detail: n }));
  }

  /* ---- open / close ------------------------------------------------- */
  function open()  { if (!root) return; syncTheme(); render(); root.classList.add('is-open'); document.body.style.overflow = 'hidden'; document.documentElement.classList.add('pv-bg-off'); }
  function close() { if (!root) return; root.classList.remove('is-open'); document.body.style.overflow = ''; document.documentElement.classList.remove('pv-bg-off'); }

  /* ---- theme sync ---------------------------------------------------- */
  /* The drawer is appended to document.body, outside each page's scoped
     wrapper, so it cannot inherit that page's accent through the cascade.
     Read the accent off the wrapper and republish it on <html> as the
     --pv-* tokens pv-cart.css already uses. Var names differ per page
     (marketing predates the --accent convention), hence the probe lists.
       .pv  home        .pvc ecommerce   .pvy youtube
       .pvp code        #curso-marketing marketing
     Surfaces are deliberately NOT synced: the pages name them
     inconsistently (--panel / --cm-surface / nothing at all), so the
     drawer keeps its own neutral dark panels. */
  var THEME_HOSTS = '[data-pv-theme],#curso-marketing,.pvy,.pvp,.pvc,.pv';

  function readVar(cs, names) {
    for (var i = 0; i < names.length; i++) {
      var v = (cs.getPropertyValue(names[i]) || '').trim();
      if (v) return v;
    }
    return '';
  }
  function syncTheme() {
    var host = document.querySelector(THEME_HOSTS);
    if (!host || !window.getComputedStyle) return;
    var cs = window.getComputedStyle(host);
    var map = [
      ['--pv-accent',      ['--accent', '--cm-accent']],
      ['--pv-accent-soft', ['--accent-soft', '--cm-accent-soft']],
      ['--pv-ink',         ['--accent-ink', '--cm-accent-ink']]
    ];
    var el = document.documentElement;
    map.forEach(function (pair) {
      var v = readVar(cs, pair[1]);
      // No value found -> leave the CSS default in place rather than blank it.
      if (v) el.style.setProperty(pair[0], v);
    });
    // No page declares a border tint, so derive it from the accent — otherwise
    // an untinted row (the bundle) would pair a red fill with a green border.
    var line = lineFrom(readVar(cs, ['--accent', '--cm-accent']));
    if (line) el.style.setProperty('--pv-accent-line', line);
  }
  // #rgb / #rrggbb -> rgba at 32%. Returns '' for any other notation, which
  // leaves the CSS default alone rather than writing something invalid.
  function lineFrom(accent) {
    var m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(accent || '');
    if (!m) return '';
    var h = m[1];
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',.32)';
  }

  /* ---- global interception ------------------------------------------ */
  // /cart/44123:1 — also matches the locale-prefixed /es/cart/44123:1
  var PERMALINK_RE = /\/cart\/(\d+)(?::\d+)?$/;
  // /cart and /es/cart, with or without a trailing slash
  var CART_PAGE_RE = /^(?:\/[\w-]+)?\/cart\/?$/;

  function onDocClick(e) {
    if (!e.target || !e.target.closest) return;

    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }

    var adder = e.target.closest('[data-cart-add], [data-cart-add-variant]');
    if (adder) {
      var vid = adder.getAttribute('data-cart-add-variant');
      if (vid) {
        e.preventDefault();
        addVariant(vid, { open: true });
      } else if (add(adder.getAttribute('data-cart-add'), { open: true })) {
        e.preventDefault();
      }
      // If the catalog id is unknown (product not published / suffix not set)
      // add() returns false and we let the href navigate instead of dead-ending.
      return;
    }

    // Any link still aimed at the cart: turn it into a drawer action.
    var a = e.target.closest('a[href]');
    if (!a || (a.host && a.host !== window.location.host)) return;
    var path = a.pathname || '';
    var m = path.match(PERMALINK_RE);
    if (m) { e.preventDefault(); addVariant(m[1], { open: true }); return; }
    if (CART_PAGE_RE.test(path)) { e.preventDefault(); open(); }
  }

  function onDocSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var field = form.querySelector('[name="id"]');
    // No variant resolved — leave it to Shopify rather than swallow the sale.
    if (!field || !field.value) return;
    e.preventDefault();
    // Stop it reaching a theme handler on the form itself (Dawn's
    // product-form would otherwise fire its own /cart/add and double the line).
    e.stopPropagation();
    addVariant(field.value, { open: true });
  }

  /* ---- init --------------------------------------------------------- */
  function init() {
    buildShell();
    // Before mounting, so the nav button and its badge are themed on arrival,
    // not only once the drawer is first opened.
    syncTheme();
    ensureButton();
    render();

    document.addEventListener('click', onDocClick);
    // Capture, so we run before any theme-level product-form handler.
    document.addEventListener('submit', onDocSubmit, true);
    window.addEventListener('cart:open', open);
    // The visible copy is bilingual markup and swaps itself; only the
    // attributes have to be rewritten when the language changes.
    document.addEventListener('pv:langchange', syncAria);
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    refreshCart().then(function () { render(); syncBadge(); }).catch(function () { syncBadge(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ---- public API --------------------------------------------------- */
  window.PVCart = {
    open: open, close: close,
    add: function (id) { return add(id, { open: true }); },
    addVariant: function (vid) { addVariant(vid, { open: true }); },
    remove: removeVariant,
    items: function () { return (cartState.items || []).slice(); },
    refresh: function () { return refreshCart().then(function () { render(); syncBadge(); }); }
  };
})();
